<template>
  <div class="text-13 h-6 flex items-center">{{ $t('evaluate_editor.crypto-jwt-verify') }}</div>
</template>

<script>
export default {
  name: 'JWTVerifyOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    payload() {
      return this.item.payload;
    },
  },
};
</script>
